import { defineComponent as s, createBlock as p, openBlock as l, resolveDynamicComponent as d, mergeProps as f, unref as e, withCtx as u, renderSlot as h } from "vue";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Form/form.js";
import { c_form_m_limit_width_MaxWidth as c } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_form_m_limit_width_MaxWidth.js";
import { useOUIAProps as y } from "../../helpers/ouia.js";
import { provideChildrenTracker as _ } from "../../use/children-tracker.js";
import { FormInputsKey as B } from "./common.js";
const F = /* @__PURE__ */ s({
  name: "PfForm",
  __name: "Form",
  props: {
    component: { default: "form" },
    horizontal: { type: Boolean },
    widthLimited: { type: Boolean },
    maxWidth: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(i, { expose: m }) {
    const r = i, a = y({ id: r.ouiaId, safe: r.ouiaSafe }), n = _(B);
    return m({
      elements: n
    }), (o, W) => (l(), p(d(o.component), f(e(a), {
      class: [e(t).form, {
        [e(t).modifiers.horizontal]: o.horizontal,
        [e(t).modifiers.limitWidth]: o.widthLimited || o.maxWidth
      }],
      style: { [e(c).name]: o.maxWidth }
    }), {
      default: u(() => [
        h(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "style"]));
  }
});
export {
  F as default
};
